import styled, { css } from 'styled-components'

import { Reset, TransitionPrimary } from '@/lib/mixins'

export const FieldNumericInput = styled.input`
  ${Reset('all')}
  appearance: none;
  width: 3.25rem;
  height: 4.25rem;
  margin: 0 0.15rem;
  font-size: 1.85rem;
  text-align: center;
  background: transparent;
  border: 1px solid ${props => props.theme.color.line};
  ${TransitionPrimary('border-color')}

  ${props =>
    props.readOnly &&
    css`
      pointer-events: none;
    `};

  &:focus {
    box-shadow: none;
    outline: 0;
  }
`

interface FieldNumericWrapperProps {
  focused?: boolean
}

export const FieldNumericWrapper = styled.div<FieldNumericWrapperProps>`
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: center;

  ${props =>
    props.focused &&
    css`
      ${FieldNumericInput} {
        border-color: currentColor;
      }
    `};
`
